import type { ElemType } from "./types";

export const COILS: ElemType[] = ["COIL", "COIL_NOT", "SET", "RESET"];
export const TIMERS: ElemType[] = ["TON", "TOF", "TP", "TONR"];
export const COUNTERS: ElemType[] = ["CTU", "CTD", "CTUD"];
export const BOXES: ElemType[] = [
  ...TIMERS,
  ...COUNTERS,
  "SR",
  "RS",
  "BOOL",
  "SELECT",
  "PROGRAM",
  "MOVE",
  "MATH",
  "WORD_LOGIC",
  "LIMIT",
  "CONVERT",
];

/** Placeholder guard kept for API stability. */
export const COILtypesGuard = (t: ElemType) => COILS.includes(t);
